
import { genericAtom } from './jotai';

export interface LoginState {
    readonly token: string;
    readonly expiresAt?: number;
    readonly tokenType?: string;
    readonly idToken?: string;
    readonly refreshToken?: string;
    readonly applyFor?: string;
    readonly isLoading?: boolean;
}

export const loginState = genericAtom<LoginState | null>(null);


export interface PreLoginState {
    readonly token: string;
    readonly expiresAt?: number;
    readonly tokenType?: string;
    readonly idToken?: string;
    readonly refreshToken?: string;
    readonly isLoading?: boolean;
}

export const preLoginState = genericAtom<PreLoginState | null>(null);


export const globalLoadingState = genericAtom<boolean | null>(false);

export const deviceState = genericAtom<'initial' | 'clean' | null>(null);

